<template>
    <div class="text-xs text-gray-500">
        {{ date }}
    </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
const props = defineProps(["date"]);

const date = computed(() => new Date(props.date).toLocaleString());
</script>
